import focusID from './$focus-id.json';
import spidrID from './$spidr-id.json';
import common from './common.json';
import securityFocuses from './security-focuses.json';
import spidrLibrary from './spidr-library.json';

const en = {
  common,
  focusID,
  securityFocuses,
  spidrID,
  spidrLibrary,
};

export default en;
